var ThemeSetting = /** @class */ (function () {
    function ThemeSetting() {
    }
    return ThemeSetting;
}());
export { ThemeSetting };
